  <app-header
    [enableBack]="true"
  ></app-header>

  <div class="p-6">
    <router-outlet></router-outlet>
  </div>

